import React, { useEffect, useState } from 'react';
import { Phone } from 'lucide-react';
import { scrollToSection } from '../utils/scrollToSection';

export default function Hero() {
  const [years, setYears] = useState(20);

  // Počítadlo let praxe — naběhne po nástupní animaci fakty lišty
  useEffect(() => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const target = 20;
    const duration = 1400;
    const start = performance.now() + 700;
    let raf;

    setYears(0);
    const tick = (now) => {
      const t = Math.min(1, Math.max(0, (now - start) / duration));
      const eased = 1 - Math.pow(1 - t, 3);
      setYears(Math.round(target * eased));
      if (t < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, []);

  const facts = [
    { value: `${years}+`, label: 'let advokátní praxe' },
    { value: '12271', label: 'evidenční číslo ČAK' },
    { value: '7 dní', label: 'v týdnu k zastižení' },
  ];

  return (
    <section id="domů" className="bg-ink-deep text-white">
      <div className="mx-auto max-w-6xl px-5 pb-14 pt-28 sm:px-8 sm:pb-16 sm:pt-40">
        <p
          className="animate-fade-up mb-5 text-xs uppercase tracking-[0.25em] text-bronze-light sm:text-sm"
          style={{ animationDelay: '100ms' }}
        >
          Advokátní kancelář · Chlumec nad Cidlinou
        </p>

        <h1
          className="animate-fade-up max-w-3xl font-serif text-4xl leading-tight sm:text-5xl lg:text-6xl"
          style={{ animationDelay: '220ms' }}
        >
          Mgr. et Bc. Lenka Ježková
        </h1>

        <p
          className="animate-fade-up mt-6 max-w-2xl text-base leading-relaxed text-slate-300 sm:text-lg"
          style={{ animationDelay: '340ms' }}
        >
          Advokátka poskytující právní služby v Chlumci nad Cidlinou a okolí —
          rodinné, trestní, pracovní a občanské právo. Více než dvacet let praxe,
          osobní přístup a srozumitelné jednání.
        </p>

        <div
          className="animate-fade-up mt-10 flex flex-col gap-3 sm:flex-row"
          style={{ animationDelay: '460ms' }}
        >
          <button
            onClick={() => scrollToSection('kontakt')}
            className="w-full bg-white px-7 py-3.5 text-base font-medium text-ink transition-all duration-300 hover:-translate-y-0.5 hover:bg-paper-dark active:translate-y-0 sm:w-auto"
          >
            Sjednat konzultaci
          </button>
          <a
            href="tel:+420721207779"
            className="flex w-full items-center justify-center gap-2.5 border border-white/25 px-7 py-3.5 text-base font-medium text-white transition-all duration-300 hover:-translate-y-0.5 hover:border-white/60 active:translate-y-0 sm:w-auto"
          >
            <Phone className="h-4 w-4" aria-hidden="true" />
            <span>+420 721 207 779</span>
          </a>
        </div>

        <dl
          className="animate-fade-up mt-14 grid grid-cols-1 gap-6 border-t border-white/10 pt-8 sm:mt-16 sm:grid-cols-3 sm:gap-10 sm:pt-10"
          style={{ animationDelay: '580ms' }}
        >
          {facts.map((fact) => (
            <div key={fact.label}>
              <dt className="sr-only">{fact.label}</dt>
              <dd>
                <span className="block font-serif text-2xl text-white sm:text-3xl">
                  {fact.value}
                </span>
                <span className="mt-1 block text-sm text-slate-400">
                  {fact.label}
                </span>
              </dd>
            </div>
          ))}
        </dl>

        <div
          className="animate-fade-up mt-12 hidden justify-center sm:flex"
          style={{ animationDelay: '800ms' }}
          aria-hidden="true"
        >
          <div className="relative h-12 w-px overflow-hidden bg-white/15">
            <span className="animate-scroll-line absolute left-0 top-0 h-4 w-px bg-bronze-light"></span>
          </div>
        </div>
      </div>
    </section>
  );
}
